/**
 *
 */
export const TYPE_SUCCESS = 'TYPE_SUCCESS';
export const TYPE_WARNING = 'TYPE_WARNING';
export const TYPE_ERROR = 'TYPE_ERROR';
